<template>
    <div
        class="px-1.5 py-0.5 inline-block rounded-md text-sm font-medium uppercase border"
        :class="color"
    >
        {{ normalizedValue }}
    </div>
</template>

<script>
export default {
    name: 'InlinePill',
    computed: {
        normalizedValue() {
            if (this.value === null || this.value === undefined) {
                return ''
            }

            return String(this.value)
        },
        color() {
            if (this.colorClass) {
                return 'border-' + this.colorClass + ' text-' + this.colorClass
            }

            const colors = [
                'indigo-600',
                'orange-600',
                'teal-600',
                'cyan-600',
                'emerald-600',
                'yellow-600',
                'purple-600',
            ]

            let hash = 0
            for (let i = 0; i < this.normalizedValue.length; i++) {
                const charCode = this.normalizedValue.charCodeAt(i)
                hash = (hash * 33 + charCode) % colors.length
            }

            return 'border-' + colors[hash] + ' text-' + colors[hash]
        },
    },
    props: {
        colorClass: {
            type: String,
        },
        value: {
            type: [String, Number],
            default: '',
        },
    },
}
</script>
